export * from './coursePaper.styled';
export * from './paperFooter';
